import { render } from "./ButtonValidate.vue?vue&type=template&id=288530fa&scoped=true&bindings={\"dark\":\"props\",\"buttonColor\":\"props\",\"buttonNowTranslation\":\"props\",\"onlyTime\":\"props\",\"noButtonNow\":\"props\",\"range\":\"props\",\"hasButtonValidate\":\"props\",\"colorStyle\":\"options\",\"bgStyle\":\"options\",\"hasButtonNow\":\"options\",\"emitNow\":\"options\"}"
import script from "./ButtonValidate.vue?vue&type=script&lang=js"
export * from "./ButtonValidate.vue?vue&type=script&lang=js"

import "./ButtonValidate.vue?vue&type=style&index=0&id=288530fa&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-288530fa"

export default script